import C from '../../constants';
import store from 'store';

import {fetchAllTenant} from "../../containers/tenant/actions/tenant";
import {fetchOwner} from "../../containers/owner/actions/owner";

export const setUser = (user) => ({
    type: C.SET_USER,
    payload: user
});

export const clearUser = () => ({
    type: C.CLEAR_USER
});

// fetch user info if token is already known
export const fetchUser = () => dispatch => {
    const user_type = store.get('type');

    if (user_type === 'tenant') {
        return dispatch(fetchAllTenant());
    } else if (user_type === 'landlord') {
        return dispatch(fetchOwner());
    }
};



// WEBPACK FOOTER //
// ./src/store/actions/user.js